/**
 * 観光スポット一覧の初期化
 */
export function initSpots($) {
  if ($('.s-spots').length === 0) return;

  // すべてのスライドを非表示にする
  $('.s-spots__seasons--slide').hide();

  // slick初期化
  $('.s-spots__seasons--slide').slick({
    slidesToShow: 1,
    centerMode: true,
    centerPadding: '0',
    infinite: true,
    arrows: true,
    dots: false,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: '0',
          variableWidth: true,
        },
      },
    ],
  });

  // 季節ボタンクリック
  $('.c-button__seasons').on('click', function() {
    const $currentSlide = $('.s-spots__seasons--slide:visible');
    const $nextSlide = $('.s-spots__seasons--' + $(this).data('season'));

    // 同じスライドがクリックされた場合は何もしない
    if ($currentSlide.is($nextSlide)) {
      return;
    }

    $('.c-button__seasons').removeClass('active');
    $(this).addClass('active');

    // 初回表示時（表示中のスライドがない場合）
    if ($currentSlide.length === 0) {
      $nextSlide.show();
      $nextSlide.slick('setPosition');
      return;
    }

    // フェードアウト
    $currentSlide.animate({ opacity: 0 }, 150, function() {
      $currentSlide.hide();
      $nextSlide.css({ opacity: 0, display: 'block' });
      $nextSlide.slick('setPosition');
      $nextSlide.animate({ opacity: 1 }, 150);
    });
  });

  // 現在月に応じてボタンを押す
  const now = new Date();
  const month = now.getMonth() + 1;

  switch (month) {
    // spring
    case 4:
    case 5:
      $('.c-button__seasons[data-season="spring"]').trigger('click');
      break;

    // summer
    case 6:
    case 7:
    case 8:
      $('.c-button__seasons[data-season="summer"]').trigger('click');
      break;

    // autumn
    case 9:
    case 10:
    case 11:
      $('.c-button__seasons[data-season="autumn"]').trigger('click');
      break;

    // winter
    case 12:
    case 1:
    case 2:
    case 3:
      $('.c-button__seasons[data-season="winter"]').trigger('click');
      break;

    default:
      $('.c-button__seasons[data-season="spring"]').trigger('click');
  }
}
